import React, { useState, useContext } from "react";
import Modal from "../Modal/Modal";
import { useModalStore } from "../../Store/ModalStore";
import styles from "./TaskModal.module.css";
import {
  CheckSubscriptionButton,
  HideTaskButton,
  SubscribeButton,
} from "./TaskModalButtons";
import { Reward } from "../Reward/Reward";
import { TasksContext } from "../../Pages/Tasks_new/provider/TasksProvider";
import {
  addTaskToBlacklist,
  getTaskTgLink,
  postPartnerTasks,
} from "../../Services/Requests";
import { TappAdsAdapter } from "../../Pages/Tasks_new/adapters/sponsors/TappAdsAdapter";
import { useNotificationStore } from "../../Store/NotificationStore";
import { useTasksStore } from "../../Store/TasksStore";

interface ClaimResponse {
  task_id: number | string;
  status: string;
  rewards_processed?: any[];
}

export const TaskModal: React.FC = () => {
  const currentTask = useModalStore((state) => state.currentTask);
  const setClosing = useModalStore((state) => state.setClosing);
  const { claimReward } = useContext(TasksContext);
  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );
  const [taskStatus, setTaskStatus] = useState(
    currentTask?.status ?? "NOT_STARTED"
  );
  let isLocked = false;

  const isTaskCompleted = currentTask?.status === "DONE";
  const setTasks = useTasksStore((state) => state.setTasks);
  const tasks = useTasksStore((state) => state.tasks);

  const handleSubscribe = async () => {
    if (!currentTask) return;

    switch (currentTask.provider) {
      case "PARTNERS":
        if (currentTask.link) {
          window.Telegram.WebApp.openTelegramLink(currentTask.link);
        }
        break;
      case "DREAMCOIN_CLICK":
        postPartnerTasks(currentTask.id).then((response) => {
          if (response) {
            if (currentTask.link) {
              window.Telegram.WebApp.openTelegramLink(currentTask.link);
            }
          }
        });
        break;
      case "DREAMCOIN_SUBSCRIBE":
        if (currentTask.link) {
          window.Telegram.WebApp.openTelegramLink(currentTask.link);
        }
        break;
      case "BARZHA":
        getTaskTgLink(currentTask.id).then((response) => {
          if (response) {
            window.Telegram.WebApp.openTelegramLink(response.url);
          }
        });
        break;
      case "BARZHA_CLICK":
        try {
          const adId = currentTask.id;
          if (!adId) {
            console.error(
              "❌ TaskModal - отсутствует ID объявления для BarzhaClick"
            );
            return;
          }

          const formData = new FormData();
          const webApp = window?.Telegram?.WebApp;
          const tgUser = webApp?.initDataUnsafe?.user;

          if (!tgUser) {
            console.error(
              "❌ TaskModal - отсутствуют данные пользователя Telegram"
            );
            return;
          }

          formData.append("tg_user_id", String(tgUser.id));
          formData.append("tg_user_first_name", tgUser.first_name);
          formData.append("tg_user_last_name", "");
          formData.append("tg_user_locale", tgUser.language_code || "");
          formData.append(
            "tg_user_is_premium",
            String(tgUser.is_premium || false)
          );
          formData.append("tg_user_device", webApp?.platform || "");

          const response = await fetch(
            `https://app.barzha.com/api/exchange/click/11/${adId}`,
            {
              method: "POST",
              body: formData,
            }
          );

          if (!response.ok) {
            throw new Error("Ошибка при отправке клика");
          }

          const data = await response.json();

          if (data.status === "success" && data.data) {
            console.log(
              "✅ TaskModal - успешный клик BarzhaClick, переход по ссылке"
            );
            window.location.href = data.data;
          } else {
            console.error("❌ TaskModal - ошибка в ответе BarzhaClick:", data);
          }
        } catch (error) {
          console.error(
            "❌ TaskModal - ошибка при выполнении задания BarzhaClick:",
            error
          );
        }
        break;
      // case "TAPPADS":
      //   TappAdsAdapter.startTask(Number(currentTask.id));
      //   break;
      case "FLYER":
        if (currentTask.link) {
          if (currentTask.link.startsWith("https://t.me/")) {
            window.Telegram.WebApp.openTelegramLink(currentTask.link);
          } else {
            window.Telegram.WebApp.openLink(currentTask.link);
          }
        }
        break;

      default:
        break;
    }
  };

  const handleClose = () => {
    setClosing(true);
  };

  const handleCheckSubscription = async () => {
    if (!currentTask) return;

    try {
      const taskId = ["FLYER", "TRAFFY"].includes(currentTask.provider)
        ? currentTask.id
        : Number(currentTask.id);
      const response = (await claimReward(taskId)) as ClaimResponse | undefined;

      if (response?.status === "CLAIMED") {
        setTaskStatus("CLAIMED");
        handleClose();
      } else {
        handleClose();
      }
    } catch (error) {
      console.error("Ошибка при получении награды:", error);
      handleClose();
    }
  };

  const handleTaskHiding = async () => {
    const tg = window.Telegram.WebApp as any;

    tg.showConfirm(
      "Вы точно хотите скрыть задание? Это действие нельзя будет отменить.",
      async (confirmed: boolean) => {
        if (confirmed) {
          const resData = await addTaskToBlacklist(currentTask);

          if (resData.error) {
            console.log(
              "❌ Error putting task to blacklist ==>",
              resData.error
            );
            setNotification({
              type: "Error",
              message: "Ошибка при скрытии задания. Попробуйте позже.",
            });

            return;
          } else {
            setTasks(tasks.filter((task) => task.id !== currentTask?.id));
            setNotification({
              type: "Success",
              message: "Задание скрыто",
            });
            setClosing(true);
          }
        }
      }
    );
  };

  if (!currentTask) return null;

  return (
    <Modal>
      <div className={styles.taskModal}>
        <div className={styles.taskHeader}>
          <div className={styles.taskIconContainer}>
            {currentTask.icon === "" || !currentTask.icon.includes("http") ? (
              <div className={styles.noTaskIcon}>
                {(() => {
                  // Регулярное выражение для проверки эмодзи
                  const emojiRegex =
                    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

                  // Проверяем, содержит ли заголовок эмодзи
                  if (emojiRegex.test(currentTask.title)) {
                    // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
                    return currentTask.title.slice(1, 2);
                  } else {
                    // Если нет эмодзи, берем первую букву
                    return currentTask.title.slice(0, 1);
                  }
                })()}
              </div>
            ) : (
              <>
                <img
                  src={currentTask.icon}
                  alt={currentTask.title}
                  className={styles.taskIcon}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    const nextElement = e.currentTarget
                      .nextElementSibling as HTMLElement;
                    if (nextElement) {
                      nextElement.style.display = "flex";
                    }
                  }}
                />
                <div className={styles.noTaskIcon} style={{ display: "none" }}>
                  {(() => {
                    // Регулярное выражение для проверки эмодзи
                    const emojiRegex =
                      /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1FAB0}-\u{1FABF}]|[\u{1FAC0}-\u{1FAFF}]|[\u{1FAD0}-\u{1FAFF}]|[\u{1FAE0}-\u{1FAFF}]|[\u{1FAF0}-\u{1FAFF}]/u;

                    // Проверяем, содержит ли заголовок эмодзи
                    if (emojiRegex.test(currentTask.title)) {
                      // Если есть эмодзи, берем второй символ (пропускаем эмодзи)
                      return currentTask.title.slice(1, 2);
                    } else {
                      // Если нет эмодзи, берем первую букву
                      return currentTask.title.slice(0, 1);
                    }
                  })()}
                </div>
              </>
            )}
          </div>
          {(() => {
            switch (currentTask.provider) {
              case "PARTNERS":
              case "BARZHA":
              case "DREAMCOIN_SUBSCRIBE":
                return (
                  <p className={styles.taskDescription}>
                    Подпишись на канал чтобы <br /> забрать награду
                  </p>
                );
              case "BARZHA_CLICK":
                return (
                  <p className={styles.taskDescription}>
                    Активируй мини-игру и получи билет!
                  </p>
                );
              case "TAPPADS":
                return (
                  <p className={styles.taskDescription}>{currentTask.title}</p>
                );
              case "FLYER":
                return (
                  <p className={styles.taskDescription}>{currentTask.title}</p>
                );
              case "DAILY":
                return (
                  <p className={styles.taskDescription}>{currentTask.title}</p>
                );
              default:
                return (
                  <p className={styles.taskDescription}>Выполни задание</p>
                );
            }
          })()}
        </div>
        <div className={styles.taskInfoContainer}>
          {(() => {
            switch (currentTask.provider) {
              case "BARZHA":
                return (
                  <>
                    <div className={styles.taskInfo}>
                      Cразу после подписки:{" "}
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                    <div className={styles.taskInfo}>
                      Будь подписан на канал 7 дней:{" "}
                      <Reward
                        type="dc"
                        amount={currentTask?.rewards?.dc ?? 0}
                      />
                    </div>
                  </>
                );
              case "TAPPADS":
                return (
                  <>
                    <div className={styles.taskInfo}>
                      После выполнения задания:{" "}
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                    <div className={styles.taskInfo}>
                      Если ты уже играл в эту игру раньше, <br /> то получишь:{" "}
                      <Reward type="ticket" amount={1} />
                    </div>
                  </>
                );
              case "FLYER":
                return (
                  <>
                    <div className={styles.taskInfo}>
                      Сразу после подписки:{" "}
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                  </>
                );

                return (
                  <>
                    <div className={styles.taskInfo}>
                      Сразу после подписки:{" "}
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                  </>
                );
              case "PARTNERS":
                return (
                  <>
                    <div className={styles.taskInfo}>
                      Cразу после подписки:{" "}
                      <Reward
                        type="dc"
                        amount={currentTask?.rewards?.dc ?? 0}
                      />
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                  </>
                );
              case "DREAMCOIN_SUBSCRIBE":
              case "DREAMCOIN_CLICK":
                if (currentTask.responseType === "channel") {
                  return (
                    <>
                      <div className={styles.taskInfo}>
                        Cразу после подписки:{" "}
                        <Reward
                          type={currentTask?.rewards?.tickets ? "ticket" : "dc"}
                          amount={
                            currentTask?.rewards?.tickets ??
                            currentTask?.rewards?.dc ??
                            0
                          }
                        />
                      </div>
                      <div className={styles.taskInfo}>
                        Будь подписан на канал 7 дней:{" "}
                        <Reward
                          type="dc"
                          amount={currentTask?.rewards?.dc ?? 0}
                        />
                      </div>
                    </>
                  );
                } else {
                  return (
                    <>
                      <div className={styles.taskInfo}>
                        После выполнения задания:{" "}
                        <Reward
                          type={currentTask?.rewards?.tickets ? "ticket" : "dc"}
                          amount={
                            currentTask?.rewards?.tickets ??
                            currentTask?.rewards?.dc ??
                            0
                          }
                        />
                      </div>
                      <div className={styles.taskInfo}>
                        Будь в числе пользователей 7 дней:{" "}
                        <Reward
                          type="dc"
                          amount={currentTask?.rewards?.dc ?? 0}
                        />
                      </div>
                    </>
                  );
                }
              case "DAILY":
              case "BARZHA_CLICK":
                return (
                  <>
                    <div className={styles.taskInfo}>
                      Сразу после выполнения задания:{" "}
                      <Reward
                        type="ticket"
                        amount={currentTask?.rewards?.tickets ?? 0}
                      />
                    </div>
                  </>
                );
              default:
                return null;
            }
          })()}
        </div>
        <div className={styles.buttons}>
          {currentTask.status !== "DONE" && (
            <SubscribeButton
              onClick={handleSubscribe}
              isLocked={isLocked}
              task={currentTask}
            />
          )}
          <CheckSubscriptionButton
            onClick={handleCheckSubscription}
            isLocked={isLocked}
            completed={isTaskCompleted}
            task={{ ...currentTask, status: taskStatus }}
          />
          {currentTask.provider === "FLYER" && (
            <HideTaskButton onClick={handleTaskHiding} task={currentTask} />
          )}
        </div>
      </div>
    </Modal>
  );
};
